<template>
  <div title="Navigation Barrierefrei" class="wrapper landscapewrapper" v-dragscroll>
    <a title="mobiles Element" class="left mobile" href="#" v-on:click="openLeft"><img class="burger" src="/img/svg/menu.svg"></a>
    <a title="Vorlesemodus umschalten" href="#" v-on:click="changeAudio"><img :src="audiosrc"></a>
    <a title="Sprache umschalten" href="#" v-on:click="changeLanguage"><img :src="langsrc"></a>
    <a title="Gebaerdensprache umschalten" href="#" v-on:click="changeDeaf"><img :src="deafsrc"></a>
  </div>
</template>

<style scoped>

</style>

<style scoped>
.landscapewrapper{
  margin-top:0px;
  height: 100vh;
  width:75px;
  z-index:10;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.wrapper a{
  width: 75px;
}

.wrapper img{
  display:block;
  width: 75px;
}

.wrapper .left img{
  display:block;
  width: 30px;
  padding: 20px;
}

@media screen and (min-width: 980px){
.wrapper{
  margin-top:0px;
  height: 100vh;
  z-index:10;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wrapper .left{
  display:none;
}

.wrapper a{
  width: 100px;
}

.wrapper img{
  display:block;
  width: 100px;
}
}

</style>

<script>
export default {
  name: 'ASSnav',
  mounted () {
    this.$store.state.mute = false
    this.deafsrc = '/img/untermenu/gebaerden.png'
    this.$store.state.srcpath = true
    this.audiosrc = '/img/untermenu/unmute.png'
    this.$store.state.deaf = false
    this.langsrc = '/img/untermenu/english.png'
  },
  data () {
    return {
      deafsrc: '/img/untermenu/gebaerden.png',
      audiosrc: '/img/untermenu/unmute.png',
      langsrc: '/img/untermenu/english.png'
    }
  },
  methods: {
    changeDeaf () {
      this.$store.state.deaf = !this.$store.state.deaf
      var slider = document.getElementsByClassName('swiper-lazy')
      if (this.$store.state.deaf) {
        this.deafsrc = '/img/untermenu/gebaerden_off.png'
        for (var i = 0; i < slider.length; i++) {
          slider[i].classList.add('swiper-deaf')
        }
      } else {
        for (var g = 0; g < slider.length; g++) {
          this.deafsrc = '/img/untermenu/gebaerden.png'
          slider[g].classList.remove('swiper-deaf')
        }
      }
    },
    changeAudio () {
      this.$store.state.mute = !this.$store.state.mute
      if (this.$store.state.mute) {
        this.audiosrc = '/img/untermenu/mute.png'
      } else {
        this.audiosrc = '/img/untermenu/unmute.png'
      }
    },
    changeLanguage () {
      if (this.$store.state.srcpath === true) {
        this.$store.commit('changeSrcPath', false)
        this.langsrc = '/img/untermenu/deutsch.png'
      } else if (this.$store.state.srcpath === false) {
        this.$store.commit('changeSrcPath', true)
        this.langsrc = '/img/untermenu/english.png'
      }
      this.$store.commit('addUpRerender')
    },
    openLeft: function () {
      if (this.$store.state.openLeft) {
        this.$store.commit('toggleLeft', false)
      } else {
        this.$store.commit('toggleLeft', true)
      }
    }
  },
  computed: {
    showSubMenu () {
      return this.$store.state.showSubMenu
    }
  }
}
</script>
